import { ProductType, ResultType } from 'features/searchResultsFacets';

const AUTO_SELECT_TARGETS = new Map([
  [
    `${ProductType.Communities.toString()}-${ResultType.Communities.toString()}`,
    {
      productType: ProductType.Homes.toString(),
      resultType: ResultType.Homes.toString(),
    },
  ],
]);

const getProductResultTypeToRedirect = (productType, resultType) =>
  AUTO_SELECT_TARGETS.get(`${productType}-${resultType}`);

export default getProductResultTypeToRedirect;
